import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X, ShoppingBag, User } from 'lucide-react';
import { supabase } from '../supabaseClient';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    setIsAdmin(!!user);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setIsAdmin(false);
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 glass-card border-b border-gray-800/50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center font-bold text-xl text-gray-900">
              SS
            </div>
            <div>
              <div className="text-xl font-bold font-poppins tracking-wide">Script Saint</div>
              <div className="text-xs text-gray-400 -mt-1">Production-Ready Code</div>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-white transition">Home</Link>
            <Link to="/shop" className="text-gray-300 hover:text-white transition">Shop</Link>
            <Link to="/portfolio" className="text-gray-300 hover:text-white transition">Portfolio</Link>
            <Link to="/about" className="text-gray-300 hover:text-white transition">About</Link>
            <Link to="/blog" className="text-gray-300 hover:text-white transition">Blog</Link>
            <Link to="/documentation" className="text-gray-300 hover:text-white transition">Docs</Link>
            {isAdmin ? (
              <>
                <Link to="/admin/dashboard" className="text-cyan-400 hover:text-cyan-300 transition flex items-center space-x-2">
                  <User size={18} />
                  <span>Dashboard</span>
                </Link>
                <button onClick={handleLogout} className="text-gray-300 hover:text-white transition">Logout</button>
              </>
            ) : (
              <Link to="/admin/login" className="text-gray-300 hover:text-white transition">Admin</Link>
            )}
            <Link to="/shop" className="gradient-button flex items-center space-x-2">
              <ShoppingBag size={18} />
              <span>Browse Products</span>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300 hover:text-white transition"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-4">
            <Link to="/" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>Home</Link>
            <Link to="/shop" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>Shop</Link>
            <Link to="/portfolio" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>Portfolio</Link>
            <Link to="/about" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>About</Link>
            <Link to="/blog" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>Blog</Link>
            <Link to="/documentation" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>Documentation</Link>
            {isAdmin ? (
              <>
                <Link to="/admin/dashboard" className="block text-cyan-400 hover:text-cyan-300 transition" onClick={() => setIsOpen(false)}>Dashboard</Link>
                <button onClick={() => { handleLogout(); setIsOpen(false); }} className="block text-gray-300 hover:text-white transition">Logout</button>
              </>
            ) : (
              <Link to="/admin/login" className="block text-gray-300 hover:text-white transition" onClick={() => setIsOpen(false)}>Admin</Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;